import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/bouman-potter.svg")